import { Button as SpectrumButton } from '@adobe/react-spectrum';

export type variant =
  | 'cta'
  | 'primary'
  | 'overBackground'
  | 'secondary'
  | 'negative';

interface ButtonProps {
  variant?: variant;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  margin?: number;
  children: React.ReactNode;
}

export const Button = (props: ButtonProps) => {
  const {
    variant = 'cta',
    onClick,
    disabled,
    className,
    margin = 10,
    children,
  } = props;

  return (
    <SpectrumButton
      UNSAFE_className={className}
      variant={variant}
      onPress={onClick}
      isDisabled={disabled}
      margin={margin}
    >
      {children}
    </SpectrumButton>
  );
};
